import { bl_fi_fixed_asset_register_depreciation_config_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterDepreciationConfigModel extends BaseContainerModel {
  bl_fi_fixed_asset_register_depreciation_config: bl_fi_fixed_asset_register_depreciation_config_RowClass = new bl_fi_fixed_asset_register_depreciation_config_RowClass();
}

export class AssetRegisterDepreciationConfigQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
}
